import React, { useEffect, useRef, useState } from "react";
import { ImageOff } from "lucide-react";
import { resolveProductImage } from "../lib/productImages";

export const ProductImage = ({ src, alt, testId, className = "", loading = "lazy" }) => {
  const source = resolveProductImage(src);
  const imageRef = useRef(null);
  const [failedSource, setFailedSource] = useState(null);
  const [loadedSource, setLoadedSource] = useState(null);
  const failed = !source || failedSource === source;
  const loaded = loadedSource === source;

  useEffect(() => {
    if (imageRef.current?.complete && imageRef.current.naturalWidth > 0) {
      setLoadedSource(source);
    }
  }, [source]);

  return (
    <div className={`relative overflow-hidden bg-[#0a0f1a] ${className}`} data-testid={`${testId}-frame`}>
      {!failed && !loaded && (
        <div className="absolute inset-0 bg-[#121824] motion-safe:animate-pulse pointer-events-none"
          aria-hidden="true" data-testid={`${testId}-loading`} />
      )}
      {failed ? (
        <div className="absolute inset-0 flex items-center justify-center text-gray-400 p-2"
          role="img" aria-label={`Photo indisponible : ${alt}`} title={`Photo indisponible : ${alt}`}
          data-testid={`${testId}-error`}>
          <ImageOff size={24} aria-hidden="true" />
        </div>
      ) : (
        <img ref={imageRef} key={source} src={source} alt={alt} loading={loading} decoding="async"
          onLoad={() => setLoadedSource(source)} onError={() => setFailedSource(source)}
          className="relative w-full h-full object-contain" data-testid={testId} />
      )}
    </div>
  );
};